import { useEffect, useState } from "react";
import AddUser from "./AddUser";
import GenericModal from "components/Modal";
import Employees from "./Employees";
import httpClient from "services/network/httpClient";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd, faEdit, faEye } from "@fortawesome/free-solid-svg-icons";
import UpdateEmployee from "./UpdateEmployee";
import Modal from "components/Modal";
import NewEmployeeDetail from "./NewEmployeeDetail";
import { sortByName } from "../../utility/sorting";
import AssignDistributors from "./AssignDistributors";
import { AnimatePresence, motion } from "framer-motion";
import InsertExcel from "components/excel/InsertExcel";

const getEmailOptions = (emailArray: any[]) =>
  emailArray.map((email: any) => ({
    value: email.id,
    label: email.firstName,
  }));


const EmployeesList = () => {
  const [isAdding, setIsAdding] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState<any>();
  const [vieData, setVieData] = useState<any>();
  const [isView, setIsView] = useState(false);
  const [emaiData, setEmailData] = useState<any[]>([]);
  const [currentEmployeeIndex, setCurrentEmployeeIndex] = useState<number>(-1);
  const [assigningDistributors, setAssigningDistributors] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState<any>();
  const [isInserting, setIsInserting] = useState(false);

  const getData = () => {
    setLoading(true);
    httpClient
      .get("employees/all?page=1&size=2000")
      .then((res: any) => {
        const sortedData = sortByName(res.value.contents, "firstName");
        setData(sortedData ?? []);
        const emailOptions = getEmailOptions(res.value.contents);
        setEmailData(emailOptions);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const handleEdit = (row: any) => {
    setIsInserting(false)
    setIsEdit(true);
    setEditData(row);
  };

  const handleView = (row: any) => {
    const index = data.findIndex(item => item.id === row.id);
    setCurrentEmployeeIndex(index);
    setIsView(true);
    setVieData(row);
  };


  const handleNextEmployee = () => {
    if (currentEmployeeIndex < data.length - 1) {
      const nextIndex = currentEmployeeIndex + 1;
      setCurrentEmployeeIndex(nextIndex);
      setVieData(data[nextIndex]);
    }
  };

  const handlePreviousEmployee = () => {
    if (currentEmployeeIndex > 0) {
      const prevIndex = currentEmployeeIndex - 1;
      setCurrentEmployeeIndex(prevIndex);
      setVieData(data[prevIndex]);
    }
  };

  const handleBackToList = () => {
    setIsView(false);
    setCurrentEmployeeIndex(-1);
  };

  const handleAssignDistributors = (row: any) => {
    // Implement the logic to assign distributors to the employee
    console.log("Assign distributors for employee: ", row);
    setSelectedEmployee(row);
    setAssigningDistributors(true);
  }

  const tableData = [
    {
      key: "reportingTo", label: "Manager Name", bold: true,
      exportLabel: "Manager Name",
      formatter: (_: any, row: any) =>
        row.managerCode && row.managerCode !== ""
          ? `${row.managerCode}/${row.reportingTo}`
          : (row.reportingTo ?? "Direct"),
      render: (_: any, row: any) => (
        <div className="flex flex-row item-center">
          <div>
            <div className="font-medium text-sm text-gray-800 dark:text-gray-200">{row.reportingTo || 'Direct'}</div>
            <div className="text-xs text-gray-500 dark:text-gray-400">
              {(row.managerCode !== "N/A") && row.managerCode}
            </div>
          </div>
        </div>
        // <span>{row.managerCode && row.managerCode !== "" ? `${row.managerCode}/${row.reportingTo}` : (row.reportingTo ?? "Direct")}</span>
      ),
    },
    {
      key: "firstName", label: "Employee Name", bold: true,
      exportLabel: "Employee Name",
      formatter: (_: any, row: any) => {
        if (row.employeeCode) {
          let name = row.firstName || "";
          if (row.lastName) {
            name += ` ${row.lastName}`;
          }
          return `${row.employeeCode}/${name}`.trim();
        } else {
          return row.firstName || "";
        }
      },
      render: (_: any, row: any) => (
        <div className="flex flex-row item-center">
          <div>
            <div className="font-medium text-gray-800 dark:text-gray-200">{row.firstName || 'Direct'}</div>
            <div className="text-xs text-gray-500 dark:text-gray-400">
              {row.employeeCode && row.employeeCode}
            </div>
          </div>
        </div>
        // <span>{row.employeeCode ? `${row.employeeCode}/${row.firstName} ${row.lastName}` : row.firstName}</span>
      ),
    },
    { key: "email", label: "Email", bold: true },
    { key: "mobile", label: "Contact Number", bold: true },
    { key: "designation", label: "Designation", bold: true },
    { key: "city", label: "City", bold: true },
    { key: "state", label: "State", bold: true },
    { key: "status", label: "Status", bold: true },


    {
      key: "actions",
      label: "Actions",
      excludeExport: true,
      actions: (row: object) => (
        <div className="flex space-x-2">
          <button
            onClick={() => handleEdit(row)}
            className="px-2 py-2 rounded-lg cursor-pointer hover:bg-blue-100 transition-colors"
            title="Edit"
            type="button"
          >
            <FontAwesomeIcon icon={faEdit} className="" />
          </button>
          <button
            onClick={() => handleView(row)}
            className="px-2 py-2 rounded-lg cursor-pointer hover:bg-green-100 transition-colors"
            title="View"
            type="button"
          >
            <FontAwesomeIcon icon={faEye} className="" />
          </button>

          <button
            onClick={() => handleAssignDistributors(row)}
            className="px-2 py-2 rounded-lg cursor-pointer hover:bg-indigo-100 transition-colors"
            title="Assign Distributors"
            type="button"
          >
            <FontAwesomeIcon icon={faAdd} className="" />
          </button>
        </div>
      ),
    },
  ];

  const handleAdd = () => {
    setIsAdding(true);
  };

  return (
    <div>
      <div className="">

        <div className="overflow-x-auto">
          {isView ? (

            <NewEmployeeDetail
              data={vieData}
              onNext={handleNextEmployee}
              onPrevious={handlePreviousEmployee}
              hasNext={currentEmployeeIndex < data.length - 1}
              hasPrevious={currentEmployeeIndex > 0}
              onBack={handleBackToList}
            />
          ) : (
            <Employees
              data={data}
              columns={tableData}
              loading={loading}
              onAdd={handleAdd}
              handleInsertClick={() => console.log()}
            />

          )}
        </div>
      </div>

      {isAdding && (
        <Modal
          isOpen={isAdding}
          onClose={() => {
            setIsAdding(false);
            setLoading(false);
          }}
          customWidth="md:max-w-6xl"
          header="Add Employee"
        >
          <AddUser
            onClose={() => setIsAdding(false)}
            getData={getData}
            emailData={emaiData}
          />
        </Modal>
      )}

      {isEdit && (
        <GenericModal
          isOpen={isEdit}
          onClose={() => setIsEdit(false)}
          header="Edit Employee"
          customWidth="md:max-w-6xl"
        >
          <UpdateEmployee
            upDatedData={editData}
            emailData={emaiData}
            getData={getData}
            onClose={() => setIsEdit(false)}
          />
        </GenericModal>
      )}
      {
        assigningDistributors && (
          <GenericModal
            isOpen={assigningDistributors}
            onClose={() => setAssigningDistributors(false)}
            header={`Assign Distributors to ${selectedEmployee?.firstName || ''} ${selectedEmployee?.lastName || ''}`}
            customWidth="md:max-w-4xl"
          >
            <AssignDistributors
              employee={selectedEmployee}
              onClose={() => setAssigningDistributors(false)}
              onSuccess={() => {
                getData();
                setAssigningDistributors(false);
              }}
            />

          </GenericModal>
        )
      }
      <AnimatePresence>
        {isInserting && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/40 flex items-center justify-center z-50"
          >
            <motion.div
              initial={{ scale: 0.9, opacity: 0, y: 30 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.25 }}
              className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl w-full max-w-lg "
            >
              <InsertExcel></InsertExcel>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default EmployeesList;
